import React, { useState } from "react";
import { CommonModal } from "../Common/CommonModal";
import SelectionCardGroup from "../Inputs/SelectionCardGroup";

export type SelectableOption = {
  id: string;
  name: string;
  description?: Maybe<string>;
};

export type SelectionModalProps<T extends SelectableOption> = {
  title: string;
  subtitle: string;
  options: Array<T>;
  primaryButtonText: string;
  closeModal: () => void;
  onSubmit: (selectedOption: T) => Promise<void>;
  loading?: boolean;
};

const SelectionModal = <T extends SelectableOption>({
  title,
  subtitle,
  options,
  primaryButtonText,
  closeModal,
  onSubmit,
  loading = false,
}: SelectionModalProps<T>) => {
  const [selectedOption, setSelectedOption] = useState<Maybe<T>>(null);

  return (
    <CommonModal
      title={title}
      subtitle={subtitle}
      content={
        <SelectionCardGroup
          orientation="vertical"
          options={options.map(option => ({
            id: option.id,
            title: option.name,
            description: option.description ?? undefined,
            value: option.id,
          }))}
          onChange={value =>
            setSelectedOption(
              options.find(option => option.id === value) ?? null,
            )
          }
        />
      }
      onCancel={closeModal}
      disabled={!selectedOption}
      onSubmit={async () => {
        if (selectedOption) {
          await onSubmit(selectedOption);
        }
      }}
      primaryButtonText={primaryButtonText}
      loading={loading}
    />
  );
};

export default SelectionModal;
